import { Router } from "components/Router/router";
import React from "react";

export const App: React.FC = () => (
  <React.Fragment>
    <Router />
  </React.Fragment>
);
